import React from 'react'
import { createBrowserRouter, Navigate } from 'react-router-dom'
import { Layout } from './layout'
import ConnectorsPage from '@/pages/connectors/index'
import LoginPage from '@/pages/login/index'
import ReauthStartPage from '@/pages/reauth/start'
import ReauthCompletePage from '@/pages/reauth/complete'

function RouteLoadingFallback() {
  return (
    <div className="container flex min-h-[40vh] items-center justify-center text-muted-foreground" role="status">
      Betöltés…
    </div>
  )
}

export const router = createBrowserRouter([
  // Minimal routes: render without admin layout (no header/menu)
  { path: '/login', element: <LoginPage /> },
  { path: '/reauth/start', element: <ReauthStartPage /> },
  { path: '/reauth/complete', element: <ReauthCompletePage /> },
  // Admin routes under layout
  {
    path: '/',
    element: <Layout />,
    HydrateFallback: RouteLoadingFallback,
    children: [
      { index: true, element: <Navigate to="connectors" replace /> },
      { path: 'connectors', element: <ConnectorsPage /> },
      { path: 'connectors/:id/logs', lazy: async () => ({ Component: (await import('@/pages/connectors/logs')).default }) },
      { path: 'imports', lazy: async () => ({ Component: (await import('@/pages/imports/index')).default }) },
      { path: 'oauth-clients', lazy: async () => ({ Component: (await import('@/pages/oauth-clients/index')).default }) },
      { path: 'queue', lazy: async () => ({ Component: (await import('@/pages/queue/index')).default }) },
      { path: 'audit', lazy: async () => ({ Component: (await import('@/pages/audit/index')).default }) },
      { path: 'issues', lazy: async () => ({ Component: (await import('@/pages/issues/index')).default }) },
    ],
  },
  // Global fallback: redirect unknown paths to /
  { path: '*', element: <Navigate to="/" replace /> },
])
